import { render, staticRenderFns } from "./SocietyDashRequestContainer.vue?vue&type=template&id=1fdfa2ae&scoped=true"
import script from "./SocietyDashRequestContainer.vue?vue&type=script&lang=js"
export * from "./SocietyDashRequestContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdfa2ae",
  null
  
)

export default component.exports